import React, {useState} from 'react' 
import { Card, Button, Input, Header, Footer, Notification} from '@scuf/common' //, ToastNotification
import { useHistory } from "react-router-dom"
import { useDispatch } from 'react-redux'

import { login } from '../../actions/authLogin'
import { msgError, removeError } from '../../actions/msgError'
import servicesAuth from '../../services/auth.services'

import '@scuf/common/honeywell-compact-combined/theme.css'
import './Login.scss'
import 'react-toastify/dist/ReactToastify.css';
import UseIconCompany from '../../customHook/useIconCompany'

const ReactToastify = import('react-toastify')

const LoginPage = () => {

    localStorage.removeItem('reduxState');
    const dispatch = useDispatch();

    var logo = 'https://www.honeywell.com/content/dam/honeywell/en-us/images/HON%20logo_200x37.png';

    const [user, setUser] = useState('') 
    const [error, setError] = useState(null)     
    const [pass, setPass] = useState('')  
    const [load, setLoad] = useState(false);

    let history = useHistory();
    
    const getData = async (e: any) => {
        e.preventDefault()
        setLoad(true);
        await servicesAuth.login(user, pass).then(
            (response) => {
                setLoad(false);
                if(response.error){ 
                    dispatch( msgError(response.error) ) 
                    setError(response.error);
                    messageToast(response.error);
                    return;
                }
                dispatch( login(response.data) )
                setLoad(false)
                dispatch( removeError() )
                history.push('/admin')
            },
            (error) => {
             
                console.log(error);
                setLoad(false);
            });
    };

    const ToastNotification = (closeToast: any, title: any ) => (
        <Notification
            className="toast-notification"
            onCloseClick={closeToast}
            hasIcon={true}
            title={title}
            severity="critical"
        />
    )

     const messageToast = async (title: any)  =>{
         (await ReactToastify).toast(<ToastNotification  closeToast={false} title={title}/>)
     }

     const toast = async () => {
         return (await ReactToastify).ToastContainer( 
            {hideProgressBar: true, 
            closeOnClick:false, 
            closeButton: false,
            newestOnTop: true,
            position:"bottom-right", 
            toastClassName:"toast-notification-wrap"});
     }

    return (
        <>
            <div className="login-page" />
            <div className='mx-auto'>
                <Card> 
                    {/*// @ts-ignore */}
                    <div className='header-absolute'>
                        {/*// @ts-ignore */}
                        <Header className='header-absolute' isForge={true} title={<UseIconCompany callback={null}></UseIconCompany>}>
                        </Header>
                    </div>
                    <Card.Content className='content-black'>
                        <form>
                        <h5  className='mb-3 text-center'>LOG IN</h5 >
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Input 
                                className="input-custom" 
                                placeholder="Fill in this field" 
                                label="User"
                                value={user} 
                                onChange={e => setUser(e)} 
                                type="text"
                                fluid={true}
                                onFocus={() => setError(null)}
                            />
                            <Input 
                                className="input-custom" 
                                placeholder="Fill in this field" 
                                label="Password"
                                value={pass} 
                                onChange={e => setPass(e)} 
                                type="password"
                                fluid={true}
                                onFocus={() => setError(null)}
                            />
                            { error == null ?<br></br> :
                            <Notification
                                hasIcon={true}
                                severity="critical">
                                {error}
                            </Notification>
                            }
                            
                            
                            <Button type="primary"
                            
                                style={{ marginTop: '10px' }}
                                disabled={load}
                                onClick={getData}
                                content="Login" 
                                actionType="submit"
                                loading={load}
                            />
                            
                        </div>
                        </form>
                    </Card.Content>
                    <Footer copyrightText="Powered by Kairos Mining" style={{ display: 'none' }}>
                        <Footer.Item href="#" >
                            <img 
                                src={logo} 
                                alt="Logo" 
                                style={{ width: '80px', marginRight: '120px' }} 
                            />  
                        </Footer.Item>
                    </Footer>
                </Card>
            </div>
            
            {
               // toast()
            }
            
        </>
    )
}

export default LoginPage
